import * as React from "react"
import { useMainContext } from "@/contexts/mainContext";
import { GLOBAL_LOADING_EVENT } from "@/services/globalLoading";

export function LoadingOverlay() {
	return (
		<div className="main-loader" role="status" aria-live="polite" aria-label="Cargando">
			<div className="main-loader__content">
				<span className="main-loader__mark" aria-hidden="true"><span /></span>
				<span className="main-loader__text">Cargando</span>
			</div>
		</div>
	);
}

export default function Loader() {
	const { mainState } = useMainContext();
	const [activeRequests, setActiveRequests] = React.useState(0);
	const [modalOpen, setModalOpen] = React.useState(false);

	const hasOpenModal = React.useCallback(() => {
		if (typeof document === "undefined") return false;
		return Boolean(document.querySelector(
			".hs-overlay.open, .hs-overlay.opened, .team-invite-modal:not(.hidden), .team-create-modal:not(.hidden), .challenge-modal:not(.hidden), .team-modal:not(.hidden), .share-post-modal:not(.hidden), .profile-edit-modal:not(.hidden), .profile-image-modal:not(.hidden)"
		));
	}, []);

	React.useEffect(() => {
		const handleLoading = (event: Event) => {
			const delta = (event as CustomEvent<{ delta?: 1 | -1 }>).detail?.delta;
			if (!delta) return;
			setActiveRequests((current) => Math.max(0, current + delta));
		};

		window.addEventListener(GLOBAL_LOADING_EVENT, handleLoading);
		return () => window.removeEventListener(GLOBAL_LOADING_EVENT, handleLoading);
	}, []);

	React.useEffect(() => {
		if (typeof document === "undefined") return;

		const updateModalState = () => setModalOpen(hasOpenModal());
		updateModalState();
		const observer = new MutationObserver(updateModalState);
		observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
		return () => observer.disconnect();
	}, [hasOpenModal]);

	const visible = !modalOpen && (mainState?.isLoading === true || activeRequests > 0);
	if (!visible) return null;

	return <LoadingOverlay />;
}
